export default __webpack_public_path__ + "static/media/team-header-logo.49fb3d78.svg";